import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';
import { FolderNode } from 'types/sequences';

interface Payload {
  folder?: FolderNode;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenDeleteFolderWarningModal = () => useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseDeleteFolderWarningModal = () =>
  useSetAtom(closeModalAtom);

export const useOpenDeleteFolderWarningModal = () => useSetAtom(payloadAtom);

export const useGetDeleteFolderWarningPayload = () => useAtomValue(payloadAtom);
